import { ReactNode } from 'react';

import style from './sectionTitle.module.scss';

type Props = {
  children: ReactNode;
  action?: ReactNode;
};

const SectionTitle = ({ children, action }: Props) => {
  return (
    <div className={style.wrapper}>
      <h4 className={style.title}>{children}</h4>
      {action}
    </div>
  );
};

export default SectionTitle;
